const feedbackInitialState = {
    hideTitle: false,
    showForm: false,
    submitted: false,
    feedbackDetails: {
        type: '',
        message: '',
    },
}

const feedbackReducer = (state, action) => {
    const { type, payload } = action

    switch (type) {
        case 'SET_HIDE_TITLE':
            return {
                ...state,
                hideTitle: payload,
            }
        case 'SET_SHOW_FORM':
            return {
                ...state,
                showForm: payload,
            }
        case 'SET_FEEDBACK_DETAILS':
            return {
                ...state,
                feedbackDetails: payload,
            }
        case 'SET_SUBMITTED':
            return {
                ...state,
                submitted: true,
            }
        case 'SET_INITIAL_STATE':
            return feedbackInitialState
        default:
            return state
    }
}

export { feedbackInitialState, feedbackReducer }
